// custom-hook for set cookie
// set login info in cookies

import Cookies from 'js-cookie';

const UseCookieStorage = (key, data, expireTime) => {
  if (data === undefined || data === null || data === '') {
    return;
  }
  const fallbackHours = 2; // 1 = 60 mins, 0.5 = 30 mins, 0.083 = 5 mins...
  const fallbackExpiry = new Date(Date.now() + fallbackHours * 60 * 60 * 1000);
  const parsedExpireTime = expireTime instanceof Date ? expireTime : new Date(expireTime);
  const isValidExpireTime = !Number.isNaN(parsedExpireTime.getTime());
  const expires =
    isValidExpireTime && parsedExpireTime.getTime() > Date.now()
      ? parsedExpireTime
      : fallbackExpiry;
  const valueToStore = typeof data === 'string' ? data : JSON.stringify(data);

  const isHttps =
    typeof window !== 'undefined' && window.location?.protocol === 'https:';

  // Important for iframe usage in modern Chrome: third-party cookies generally require
  // SameSite=None; Secure (when cookies are allowed/partitioned).
  Cookies.set(key, valueToStore, {
    expires,
    path: '/',
    sameSite: isHttps ? 'None' : 'Lax',
    secure: isHttps,
  });
};

export default UseCookieStorage;
